export default "__VITE_ASSET__BD0T1VYu__"